import type {
  Message,
  MessageEventListenerOptions,
  TargetContext,
  TargetPostMessageOptions,
} from 'src/target/context';

/**
 * Create a TargetContext from a MessagePort.
 * @param port The MessagePort to create the TargetContext from.
 */
export function targetContextFromMessagePort(port: MessagePort): TargetContext {
  return {
    ref: port,
    fromValidContext(): boolean {
      // MessagePort does not have origin or source properties since it is expected to only be
      // usable between known contexts, so we cannot validate them.
      return true;
    },
    postMessage(message: unknown, opts: TargetPostMessageOptions): void {
      port.postMessage(message, opts);
    },
    addMessageEventListener<T = unknown>(
      listener: (event: Message<T>) => void,
      {signal}: MessageEventListenerOptions,
    ): void {
      port.addEventListener('message', listener, {
        signal, // Attach the signal to allow for aborting the listener
      });
    },
    removeMessageEventListener<T = unknown>(
      listener: (message: Message<T>) => void,
    ): void {
      port.removeEventListener('message', listener);
    },
  };
}
